import React from "react";
import { SpaceBetween, Box } from "@cloudscape-design/components";

const FinancePaymentCommsHelp = () => (
  <SpaceBetween size="m">
    <Box>
      <strong>Purpose</strong>
      <p>
        Review communications and supporting documents for the selected payment packet.
      </p>
    </Box>
    <Box>
      <strong>What shows up here</strong>
      <ul>
        <li>Emails sent when packets are sent to finance.</li>
        <li>Manually logged outbound or inbound communications.</li>
        <li>Attachment counts for evidence bundles.</li>
      </ul>
    </Box>
    <Box>
      <strong>How to use</strong>
      <ul>
        <li>Select a packet in the queue to see its communications.</li>
        <li>Filter or search the table by packet ID, subject, or recipient to locate past messages.</li>
        <li>Click a communication row or its subject to open the content viewer.</li>
        <li>The Communication tab uses the current Finance template and packet data for generated payment emails, or the recorded notes for manually logged messages.</li>
        <li>In Bundle documents, select a document to read it beside the list. PDF, image, and Word previews open inside PATH.</li>
      </ul>
    </Box>
    <Box>
      <strong>Next steps</strong>
      <p>
        Use this log to confirm when packets were sent and which packets still need follow-up.
      </p>
    </Box>
  </SpaceBetween>
);

FinancePaymentCommsHelp.aiContext =
  "Explain the Payments communications log for the selected packet: automatic payment email entries and manually logged inbound/outbound messages. Search by packet, subject, or recipient. Click a row or its subject to open Communication and Bundle documents tabs. Generated payment communications use the current Finance template with current packet data; manual messages show their recorded notes. Bundle documents are the packet's currently linked active evidence and can be previewed inside PATH. This viewer does not retain additional email or document snapshots; the email itself remains the record of what was sent.";

export default FinancePaymentCommsHelp;
